import React, { Component } from "react";
import { Card, CardHeader, CardBody, UncontrolledAlert } from "reactstrap";

import DataTable from "../../Shared/DataTable";
import { MdDone, MdClear, MdSearch } from "react-icons/md";
// import { NavLink } from "react-router-dom";
import { AdminViewSpecificDailyMealPlans } from "../../../_constants/RouteVariables";
import Moment from "moment";
import { GoClock } from "react-icons/go";

const Approved = () => {
    return (
        <span style={{ color: "green" }}>
            <MdDone /> Approved
        </span>
    );
};
const Declined = () => {
    return (
        <span style={{ color: "red" }}>
            <MdClear /> Redraft
        </span>
    );
};

const Pending = () => {
    return (
        <span style={{ color: "#808080" }}>
            <GoClock /> Pending
        </span>
    );
};

export class AdminPendingMealPlanTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: "all",
        };
    }

    filterDraftStatus = (data) => {
        let filterData = data
            .filter((value) => {
                return value.status !== "DRAFT";
            })
            .map((value) => {
                return value;
            });

        return filterData;
    };

    render() {
        const columns = [
            {
                Header: "Name",
                accessor: "name",
            },

            {
                Header: "Date",
                id: "createdAt",
                maxWidth: 180,
                accessor: (d) => {
                    return Moment(d.createdAt).local().format("DD-MM-YYYY ");
                },
            },
            {
                Header: "Status",
                accessor: "status",

                id: "status",

                Cell: (row) => <span>{row.value === "APPROVED" ? <Approved /> : row.value === "PENDING" ? <Pending /> : <Declined />}</span>,
            },
        ];

        const { match, fetching, data, error, selectRow, deleteInterest, showModal, pages, page, pageSize, setPageNumber, filterData, setPageSize } = this.props;

        const actions = [
            {
                name: "view",
                btnText: "View",
                isLink: true,
                isMealPLan: true,
                to: AdminViewSpecificDailyMealPlans,
                btnAction: selectRow,
                btnClass: "btn-success",
                btnIcon: MdSearch,
            },
        ];
        return (
            <div>
                <Card>
                    <CardHeader>Meal Plans</CardHeader>
                    <CardBody className="joyride10">
                        {error && <UncontrolledAlert color="danger">{error.message}</UncontrolledAlert>}

                        <DataTable
                            columns={columns}
                            loading={fetching}
                            urlParams={match}
                            // data={this.filterDraftStatus(mockdata)}
                            data={data ? this.filterDraftStatus(data.data) : []}
                            count={data ? this.filterDraftStatus(data.data).length : 0}
                            defaultPageSize={5}
                            deleteRow={deleteInterest}
                            selectRow={selectRow}
                            showModal={showModal}
                            manual={true}
                            pages={pages}
                            page={page}
                            pageSize={pageSize}
                            filterData={filterData}
                            isView={true}
                            setPageNumber={setPageNumber}
                            setPageSize={setPageSize}
                            searchParam="searchKey"
                            hideSearchParam={true}
                            // searchPlaceholder="Search by title"
                            actions={actions}
                        />
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default AdminPendingMealPlanTable;
